import { render, staticRenderFns } from "./ClientList.vue?vue&type=template&id=c1d5561a"
import script from "./ClientList.vue?vue&type=script&lang=js"
export * from "./ClientList.vue?vue&type=script&lang=js"
import style0 from "./ClientList.vue?vue&type=style&index=0&id=c1d5561a&prod&lang=scss"
import style1 from "./ClientList.vue?vue&type=style&index=1&id=c1d5561a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports